import {
    tss,
} from 'app/tss'

const general = 'general'
const handover = 'handover'
const collection = 'collection'
const productTypes = 'productTypes'
const consignee = 'consignee'
const customerExecution = 'customerExecution'

export default tss
    .withParams<{ showProductTypes: boolean, showHandoverCollectionSection: boolean }>()
    .create(({
        theme, showProductTypes, showHandoverCollectionSection,
    }) => {
        let gridTemplateAreas = `
                "${general} ${general}"
                `

        if (showHandoverCollectionSection) {
            gridTemplateAreas += `
                "${handover} ${collection}"
                `
        }

        if (showProductTypes) {
            gridTemplateAreas += `
                "${productTypes} ${productTypes}"
                `
        }

        return {
            gridWrapper: {
                display: 'grid',
                gridGap: theme.spacing(2),
                gridTemplateAreas,
                gridTemplateColumns: 'repeat(2, 2fr)',
            },
            general: {
                gridArea: general,
                height: 'fit-content',
            },
            handover: {
                gridArea: handover,
            },
            collection: {
                gridArea: collection,
            },
            productTypes: {
                gridArea: productTypes,
            },
            consignee: {
                gridArea: consignee,
            },
            customerExecution: {
                gridArea: customerExecution,
            },
            green: {
                '&&': {
                    color: `${theme.palette.common.green} !important`,
                },
            },
            red: {
                '&&': {
                    color: `${theme.palette.common.red} !important`,
                },
            },
        }
    })
